<div mat-dialog-title
     class="title">
    <button mat-icon-button
            mat-dialog-close
            tabindex="-1"
            [matTooltip]="'Close' | translate"
            class="close-button hidden">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <session-exercice-duration *ngIf="data?.data.exercice.exercice.exerciceType === EXERCICE_TYPE_DURATION"
                               [data]="data"
                               [organization]="organization"
                               [isEditable]="false">
    </session-exercice-duration>
    <session-exercice-repeat *ngIf="data?.data.exercice.exercice.exerciceType === EXERCICE_TYPE_REPEAT"
                             [data]="data"
                             [organization]="organization"
                             [isEditable]="false">
    </session-exercice-repeat>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="actions">
        <button mat-raised-button
                mat-dialog-close
                color="accent">
            {{ 'Close' | translate}}
        </button>
    </div>
</mat-dialog-actions>
